//https://stackoverflow.com/questions/48514773/use-history-push-in-action-creator-with-react-router-v4
import createBrowserHistory from 'history/createBrowserHistory';
export const history = createBrowserHistory();

export const baseUrl = 'https://kooleposhti.ml/api/v1';
